// Audit actions mapped to Pill tones. Creation is good news, deletion
// demands attention, a status change is worth a second look, and an update
// is routine.

export const auditActionTone = {
  CREATE: 'ok',
  UPDATE: 'neutral',
  DELETE: 'bad',
  STATUS_CHANGE: 'warn',
}
